
import { defineComponent, ref, onMounted, onUnmounted, nextTick, watch } from "vue";
import { ElCard, ElInput, ElButton, ElPopover, ElMessage, ElMessageBox, ElBacktop } from "element-plus";
import { EventSourcePolyfill } from 'event-source-polyfill'


import localCache from "@/utils/cache";
import { loadHistory, loadMessages, deleteHistory } from "@/service/main/ai/aiInterface";
import MarkdownIt from "markdown-it";

interface Message {
  type: 'user' | 'ai';
  content: string;
  sessionId: string;
  requestId?: string;
}

export default defineComponent({
  components: {
    ElCard,
    ElInput,
    ElButton,
    ElPopover,
    ElBacktop
  },
  setup() {
    const md = new MarkdownIt();
    const loading = ref(false);
    const keyword = ref('');
    const messages = ref<Message[]>([]);
    const inputMessage = ref('');
    const evtSource: any = ref(null);

    const sessionId = ref('')
    const requestId = ref('')

    const compiledMarkdown = (content: string) => {
      return md.render(content);
    };

    const sendMessage = () => {
      if (inputMessage.value.trim() === '') return;

      loading.value = true
      // 用户消息
      messages.value.push({ type: 'user', content: inputMessage.value, sessionId: sessionId.value });
      nextTick(() => {
        chatBox.value.scrollTop = chatBox.value.scrollHeight;
      })
      const token = localCache.getCache('token')
      let tempresp = '';
      evtSource.value = new EventSourcePolyfill(process.env.VUE_APP_BASE_URL + '/main/ai/twai?userContent='+ inputMessage.value + '&sessionId=' + sessionId.value, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      evtSource.value.onmessage = (event: any) => {
        console.log('New message:', event.data);
        const resp = JSON.parse(event.data)
        sessionId.value = resp.sessionId
        requestId.value = resp.requestId
        // 处理接收到的消息, 如何将多次的消息合并成一个完整的消息
        if (resp.content === '[DONE]') {
          loading.value = false
          pageNo.value = 0
          fetchSessionGroups()
          evtSource.value.close()
          return
        } else {
          tempresp += resp.content
          // 将消息添加到数组中
          let obj = messages.value.find((item) => item.requestId == resp.requestId)
          if (obj) {
            obj.content = tempresp
          } else {
            messages.value.push({ type: 'ai', content: tempresp, sessionId: resp.sessionId, requestId: resp.requestId })
          }
          nextTick(() => {
            chatBox.value.scrollTop = chatBox.value.scrollHeight;
          })
        }
      };

      evtSource.value.onerror = (error: any) => {
        console.log('New message:', error);
        evtSource.value.close()
        loading.value = false
      };


      // 清空输入框
      inputMessage.value = '';
    };

    const stopMsg = () => {
      evtSource.value.close()
      loading.value = false
    }

    const inputOpen = ref(false)
    const searchInput: any = ref(null)
    const showSearch = () => {
      // 显示搜索框
      inputOpen.value = true
      console.log('111111111111')
      nextTick(()=>{
        searchInput.value?.focus()
      })
    }
    const hideSearch = () => {
      // 隐藏搜索框
      inputOpen.value = false
    }

    const sessionGroups = ref<any[]>([])
    const pageSize = ref(15)
    const pageNo = ref(0)

    watch(
      keyword,
      (newKeyword: any) => {
        if (newKeyword) {
          pageNo.value = 0
          fetchSessionGroups()
        }
      },
      { deep: true, immediate: false }
    )

    const now = new Date();
// 定义各个时间段
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const sevenDaysAgo = new Date(todayStart.getTime() - 7 * 24 * 60 * 60 * 1000);
    const thirtyDaysAgo = new Date(todayStart.getTime() - 30 * 24 * 60 * 60 * 1000);
    const halfYearAgo = new Date(todayStart.getTime() - 180 * 24 * 60 * 60 * 1000);
    const oneYearAgo = new Date(todayStart.getTime() - 365 * 24 * 60 * 60 * 1000);

    const insertTimeDividers = (items: any) =>{
      let lastCategory = '';
      const categories = ['当天', '最近7天', '最近30天', '最近半年', '最近一年'];
      return items.reduce((accumulator: any, item: any) => {
        const createTime = new Date(item.createdTime);

        let category;
        if (createTime >= todayStart) {
          category = categories[0];
        } else if (createTime >= sevenDaysAgo) {
          category = categories[1];
        } else if (createTime >= thirtyDaysAgo) {
          category = categories[2];
        } else if (createTime >= halfYearAgo) {
          category = categories[3];
        } else if (createTime >= oneYearAgo) {
          category = categories[4];
        } else {
          // 超过一年的数据不处理或按需处理
          accumulator.push(item);
          return accumulator;
        }

        // 插入分隔符
        if (lastCategory !== category) {
          accumulator.push({ divider: category });
          lastCategory = category;
        }
        accumulator.push(item);
        return accumulator;
      }, []);
    }

    const initMessages = () => {
      messages.value = []
      sessionId.value = ''
    }
    const total = ref(0)
    const fetchSessionGroups = () => {
      pageNo.value++
      const params = {
        pageNo: pageNo.value,
        pageSize: pageSize.value,
        keyword: keyword.value
      }
      loadHistory(params).then((res: any) => {
        if (res) {
          total.value = res.total
          if(pageNo.value > 1) {
            sessionGroups.value = [...sessionGroups.value, ...res.list]
          } else {
            sessionGroups.value = res.list
          }
          sessionGroups.value = sessionGroups.value.filter((item: any) => !item.divider)
          sessionGroups.value = insertTimeDividers(sessionGroups.value)
        }
      })
    }

    const loadData = (sid: string) => {
      sessionId.value = sid
      const params = {
        sessionId: sid
      }
      loadMessages(params).then((res: any) => {
        messages.value = res;
      })
    }

    const scrollContainer: any = ref(null);
    const chatBox: any = ref(null);

    const handleScroll = () => {
      if (!scrollContainer.value) return;
      const { scrollTop, scrollHeight, clientHeight } = scrollContainer.value;
      if (scrollTop + clientHeight >= scrollHeight - 1) { // 接近底部
        if (sessionGroups.value.filter((item: any) => !item.divider).length < total.value){
          fetchSessionGroups();
        }
      }
    };

    const deleteSession = (sid: string) => {
      ElMessageBox.confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除操作
        deleteHistory({ sessionId: sid }).then((res: any) => {
          if (res) {
            ElMessage.success('删除成功')
            sessionId.value = ''
            pageNo.value = 0
            fetchSessionGroups()
            messages.value = []
          }
        })
      }).catch(() => {
        // 取消操作
      });
    }


    onMounted(() => {
      fetchSessionGroups()
      scrollContainer.value.addEventListener('scroll', handleScroll);
    });

    return {
      messages,
      inputMessage,
      sendMessage,
      keyword,
      inputOpen,
      showSearch,
      hideSearch,
      searchInput,
      sessionGroups,
      fetchSessionGroups,
      initMessages,
      loadData,
      loading,
      stopMsg,
      evtSource,
      compiledMarkdown,
      sessionId,
      scrollContainer,
      deleteSession,
      chatBox
    };
  },
});
